import { useState, useEffect, useCallback } from 'react';
import { message } from 'antd';
import BookingsService from '../../../services/bookings/service'; // You will create this service

export const useBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchBookings = useCallback(async () => {
    setLoading(true);
    try {
      const data = await BookingsService.fetchBookings(); // Fetch from your API
      setBookings(data);
    } catch (error) {
      message.error('Failed to fetch bookings');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchBookings();
  }, [fetchBookings]);

  return {
    bookings,
    loading,
    refreshBookings: fetchBookings
  };
};
